import React, { useEffect, useState } from "react";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import DropDown from "../../../components/styled-components/dropdown/dropdown";
import helpIcon from "../../../assets/images/DeathModuleNew/infoIcon.png";
import { defaultStyles } from "../../../constants/style-constants/utils";
import {
  Radio,
  DatePicker,
  Button,
  Collapse,
  Select,
  InputNumber,
  Modal,
  Icon,
  Spin,
  AutoComplete,
  Input,
} from "antd";
import * as Styles from "../Styles/InsuranceSubformStyle";
import InsuranceSubFormTable from "./InsuranceSubFormTable";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import { MODULE_API } from "../../../apis";
import FETCH from "../../../utils/fetch";
import swal from "sweetalert";
import axios from "axios";
import { UmbrellaInsuranceTable } from "./UmbrellaInsuranceTable";
import { AddOwnerModal } from "../../ManageOwners/component/AddOwnerModal";
const Options = AutoComplete.Option;

export const FormCreator = ({
  data,
  attributes,
  values,
  title,
  setSubmitBody,
  activeTabName,
}) => {
  const { Panel } = Collapse;
  const [inputFields, setInputFields] = useState([]);
  const [groupedFields, setGroupedFields] = useState({});
  const [payload, setPayload] = useState({});
  const [attributeValues, setAttributeValues] = useState({});
  const [tabRows, setTabRows] = useState({});
  const [tooltipModal, setTooltipModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ownerList, setOwnerList] = useState([]);
  const [formDataOwner, setFormDataOwner] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };

  const handleChangeOwner = (name, value) => {
    setFormDataOwner({
      ...formDataOwner,
      [name]: value,
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setFormDataOwner(null);
  };

  const handleSave = async () => {
    setIsModalOpen(false);
    try {
      let payload = {
        ...formDataOwner,
      };

      setIsLoading(true);
      let data = await MODULE_API.addAsset("Owners and Entities", {
        clientModules: [{ ...payload }],
      });
      if (data && data.statusCode === 201) {
        swal("Success", "Owner Details Added Successfully.", "success");
        await getOwnersDetails(1);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
    setFormDataOwner(null);
  };

  const getOwnersDetails = async (page) => {
    try {
      // setLoading(true);
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Owners and Entities&page=${page}&limit=30&clientId=${ID}`
            : `?module=Owners and Entities&page=${page}&limit=30`,
        body: {},
      });
      if (datares && datares.records) {
        setOwnerList(datares.records);
      }
      // setLoading(false);
    } catch (error) {
      console.log(error);
      // setLoading(false);
    }
  };

  useEffect(() => {
    getOwnersDetails(1);
  }, []);

  useEffect(() => {
    if (data && Object.keys(data)) {
      setInputFields(Object.keys(data));
    }
  }, [data]);

  useEffect(() => {
    setSubmitBody(payload);
  }, [payload]);

  useEffect(() => {
    setAttributeValues(values);
    setPayload(values);
  }, [values]);
  useEffect(() => {
    let allValues = payload || values;
    const inputFieldIds =
      inputFields && inputFields.map((id) => parseInt(id, 10));
    const filteredAttributes =
      attributes &&
      attributes.filter((attr) => inputFieldIds.includes(attr.id));
    console.log("filteredAttributes", filteredAttributes);
    const attributeNames =
      filteredAttributes && filteredAttributes.map((attr) => attr.name);

    // Filter allValues to get only the attributes matching attributeNames
    const matchingValues = {};
    attributeNames.forEach((name) => {
      if (allValues.hasOwnProperty(name)) {
        matchingValues[name] = allValues[name];
      }
    });

    // Convert the payload to rows for all array values
    const payloadTab = {};
    Object.keys(matchingValues).forEach((key) => {
      if (Array.isArray(matchingValues[key])) {
        payloadTab[key] = matchingValues[key];
      }
    });
    console.log("payloadTab", payloadTab);
    const rows = convertPayloadToRows(payloadTab);
    console.log("Converted Rows: ", rows);
    setTabRows((prevTabRows) => ({
      ...prevTabRows,
      [activeTabName]: rows,
    }));
    // You can set the rows state here, e.g., setRows(rows);
    // Assuming you have a setRows function in your component
  }, [data, inputFields, values]);
  useEffect(() => {
    console.log("hardcoded inputFields", inputFields, data, attributes);

    const inputFieldIds =
      inputFields && inputFields.map((id) => parseInt(id, 10));
    const filteredAttributes =
      attributes &&
      attributes.filter((attr) => inputFieldIds.includes(attr.id));

    // Filter out attributes where formGroupName is null
    const validAttributes =
      filteredAttributes &&
      filteredAttributes.filter((attr) => attr.formGroupName);

    // Group attributes by formGroupName
    const groupedAttributes = validAttributes.reduce((acc, attr) => {
      const group = attr.formGroupName;
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(attr);
      return acc;
    }, {});

    console.log("groupedAttributes", groupedAttributes, filteredAttributes);

    // Generate columns for each formGroupName
    const groupedCols = Object.entries(groupedAttributes).map(
      ([groupName, attrs]) => {
        const cols = attrs.map((attr) => ({
          title: attr.name,
          dataIndex: attr.name,
          key: attr.name,
          fields: [
            {
              type: attr.dataType,
              name: attr.name,
            },
          ],
        }));
        return {
          groupName,
          cols,
          groupAttributes: groupedAttributes[groupName],
        };
      }
    );

    console.log("groupedCols", groupedCols);
    setGroupedFields(groupedCols);
  }, [data, inputFields, attributes]);
  const handleFormInputChange = (title, rows) => {
    console.log("rowsAsss", rows, title);
    setTabRows((prevTabRows) => ({
      ...prevTabRows,
      [activeTabName]: rows,
    }));

    setPayload((prevValue) => {
      // Create a new payload object based on the previous state
      const updatedPayload = { ...prevValue };

      // Extract field names dynamically from rows
      // if (rows.length === 0) {
      //   Object.keys(updatedPayload).forEach((key) => {
      //     delete updatedPayload[key];
      //   });
      //   return updatedPayload;
      // }
      // this is for deleting rows
      const activeTabRows = tabRows[activeTabName] || [];

      // Iterate over each row in the active tab rows
      activeTabRows.forEach((row) => {
        Object.keys(row).forEach((key) => {
          if (key !== "key") {
            // If the key exists in the payload, remove it
            if (updatedPayload[key]) {
              delete updatedPayload[key];
            }
          }
        });
      });
      const areAllRowsEmpty = rows.every((row) =>
        Object.keys(row).every((key) => key === "key" || row[key] === null)
      );
      // console.log("activeTabName44",activeTabName,activeTabRows)

      // this is for end deleting rows
      const fields = new Set();
      rows.forEach((row) => {
        Object.keys(row).forEach((key) => {
          if (key !== "key") {
            // Exclude the 'key' property
            fields.add(key);
          }
        });
      });

      // Initialize arrays for each field in the payload
      fields.forEach((field) => {
        updatedPayload[field] = [];
      });

      // Iterate over each row
      console.log("isRowEmpty", rows, activeTabRows);
      rows.forEach((row) => {
        // Check if the row is completely null or empty
        const isRowEmpty = Object.keys(row).every(
          (key) => key === "key" || row[key] === null
        );
        if (!isRowEmpty) {
          // Iterate over each key-value pair in the row
          Object.keys(row).forEach((key) => {
            if (key !== "key") {
              // Exclude the 'key' property from the payload
              // Ensure the key exists in the payload object
              if (!updatedPayload[key]) {
                updatedPayload[key] = [];
              }

              // Add or replace the value at the corresponding index
              const index = parseInt(row.key, 10) - 1; // Assuming 'key' is 1-based index

              // Ensure the array is long enough
              if (index >= updatedPayload[key].length) {
                updatedPayload[key].length = index + 1;
              }

              // Update the value at the specific index
              updatedPayload[key][index] = row[key];
            }
          });
        }
      });

      // Remove trailing empty/null values in each field array
      Object.keys(updatedPayload).forEach((field) => {
        if (Array.isArray(updatedPayload[field])) {
          updatedPayload[field] = updatedPayload[field].filter(
            (value) => value !== null
          );
        }
      });
      console.log("updatedPayload", updatedPayload);
      if (
        areAllRowsEmpty &&
        activeTabName === "ASSISTANCE FROM FRIENDS AND FAMILY"
      ) {
        // If all rows are empty, initialize payload keys with empty arrays
        updatedPayload["Date"] = [null];
        updatedPayload["Person Providing Assistance"] = [null];
        updatedPayload["Relationship"] = [null];
        updatedPayload["Amount Received"] = [null];
        // return updatedPayload; // Exit early if all rows are empty
      }
      return updatedPayload;
    });
  };

  const convertPayloadToRows = (payload) => {
    // Get the field names from the payload, excluding the fields that are arrays
    const fields = Object.keys(payload).filter((key) =>
      Array.isArray(payload[key])
    );

    // Determine the number of rows based on the length of the arrays in the payload
    const numberOfRows = Math.max(
      ...fields.map((field) => payload[field].length)
    );

    // Create the rows array
    const rows = Array.from({ length: numberOfRows }, (_, index) => {
      const row = { key: (index + 1).toString() };

      // Populate each row with data from the payload
      fields.forEach((field) => {
        row[field] = payload[field][index] || ""; // Use empty string if value is undefined
      });

      return row;
    });
    setTabRows((prevTabRows) => ({
      ...prevTabRows,
      [activeTabName]: rows,
    }));
    return rows;
  };
  // const handleInputFields = (inputName, value) => {
  //   // setPayload((prevValue) => ({ ...prevValue, [inputName]: value }));
  //   setPayload((prevValue) => {
  //     if (
  //       inputName === "Will you need a loan for this goal?" &&
  //       value === true
  //     ) {
  //       return {
  //         ...prevValue,
  //         [inputName]: value,
  //         //   "Total Loan assigned to goal": calculateLoanForGoal(),
  //       };
  //     }
  //     // Otherwise, just update the payload with the inputName and value
  //     return {
  //       ...prevValue,
  //       [inputName]: value,
  //       ["Premium"]: 0,
  //     };
  //   });
  // };

  const handleInputFields = (inputName, value) => {
    setPayload((prevValue) => {
      const updatedPayload = {
        ...prevValue,
        [inputName]: value,
      };

      const medicareType = updatedPayload["Medicare Type"];

      const getNumericValue = (fieldName) => {
        const val = parseFloat(updatedPayload[fieldName]);
        return isNaN(val) ? 0 : val;
      };

      if (medicareType === "Original Medicare") {
        const partB = getNumericValue("Part B (Medical Insurance) Premium");
        const medigap = getNumericValue(
          "Medigap Supplement Plan Monthly Premium"
        );
        const partD = getNumericValue(
          "Part D (Prescription Drug Plan) Monthly Premium"
        );

        updatedPayload["Premium"] = partB + medigap + partD;
      } else if (medicareType === "Medicare Advantage") {
        const partA = getNumericValue("Part B (Medical Insurance) Premium");
        const partC = getNumericValue(
          "Part C (Medicare Advantage) Monthly Premium"
        );

        updatedPayload["Premium"] = partA + partC;
      }

      return updatedPayload;
    });
  };

  const dependentInputFieldsOriginalMedicare = [
    "Part A (Hospital Insurance) Premium",
    "Part A Deductible (Per Benefit Period)",
    "Part B (Medical Insurance) Premium",
    "Part B (Medical Insurance) Deductible",
    "Medigap Supplement Plan Carrier",
    "Medigap Supplement Plan Plan Type",
    "Medigap Supplement Plan Monthly Premium",
    "Medigap Supplement Plan Policy ID",
    "Part D (Prescription Drug Plan) Carrier",
    "Part D (Prescription Drug Plan) Plan Name",
    "Part D (Prescription Drug Plan) Monthly Premium",
    "Part D (Prescription Drug Plan) Annual Deductible",
    "Part D (Prescription Drug Plan) Policy ID",
  ];
  const dependentInputFieldsMedicareAdvantage = [
    "Part B (Medical Insurance) Premium",
    "Part C (Medicare Advantage) Carrier",
    "Part C (Medicare Advantage) Plan Name",
    "Part C (Medicare Advantage) Network Type",
    "Part C (Medicare Advantage) Monthly Premium",
    "Part C (Medicare Advantage) Policy ID",
    "Part C (Cost Structure) Annual Medicaid Deductible",
    "Part C (Cost Structure) Maximum Out of Pocket",
    "Part C (Cost Structure) Primary Care Physician Copay",
    "Part C (Cost Structure) Specialist Copay",
    "Part C (Cost Structure) Notes",
    "Part C (Prescription Drug Details) Include Drug Coverage",
    "Part C (Prescription Drug Details) Annual Drug Deductible",
  ];

  const isDependentInputField = (payload, inputName) => {
    const medicareType = payload["Medicare Type"];

    // If inputName is not a dependent field, show it
    if (
      !dependentInputFieldsOriginalMedicare.includes(inputName) &&
      !dependentInputFieldsMedicareAdvantage.includes(inputName)
    ) {
      return true;
    }

    // If Medicare Type is not set, hide dependent fields
    if (!medicareType) {
      return false;
    }

    // Show fields based on Medicare Type
    if (medicareType === "Original Medicare") {
      return dependentInputFieldsOriginalMedicare.includes(inputName);
    } else if (medicareType === "Medicare Advantage") {
      return dependentInputFieldsMedicareAdvantage.includes(inputName);
    }

    return false;
  };

  const handleFileChange = async (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      if (e.target.files) {
        setIsLoading(true);
        let uploadedFile = e.target.files[0];
        const formData = new FormData();
        formData.append("file", uploadedFile);
        const name = uploadedFile.name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        handleInputFields("File Name", fileName);
        const resdata = await MODULE_API.uploadFile({
          fileExt: ext,
          contentType: uploadedFile.type,
        });
        const resupload = await axios.put(resdata.uploadUrl, uploadedFile, {
          headers: { "Content-type": uploadedFile.type },
        });
        setIsLoading(false);
        const imgUrl = resdata.uploadUrl.split("?")[0];
        return imgUrl;
      }
    } catch (e) {
      console.log("error", e);
      swal("Error!", "File Size Too Big!", "error");
      setIsLoading(false);
    }
  };
  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1]; // Get the last part of the URL, which is the file name
  };
  const DynamicComponentGenerator = (item) => {
    if (data[item]) {
      if (!isDependentInputField(payload, data[item].name)) {
        return <React.Fragment key={item}></React.Fragment>;
      }
      if (data[item].formGroupName) {
        return <React.Fragment></React.Fragment>;
      } else {
        return SubFieldGenerator(data[item]);
      }
    }
  };
  const SubFieldGenerator = (item) => {
    const { view } = useParams();
    const { module } = useParams();
    // console.log(
    //   "isDependentInputField",
    //   isDependentInputField(
    //     dependentAttributes,
    //     dependentInputFields,
    //     payload,
    //     item.name
    //   )
    // );
    if (!isDependentInputField(payload, item.name)) {
      return null;
    }
    switch (item.dataType) {
      case "boolean":
        return (
          <Styles.SubFormDiv
            style={{
              marginTop: "0.5rem",
              display: item.name === "Under the Umbrella" && "none",
            }}
          >
            <label style={{ display: "flex", flexDirection: "column" }}>
              {item.name}
              <Radio.Group
                disabled={view}
                style={{ marginTop: "0.5rem" }}
                value={
                  payload[item.name] && payload[item.name] === true
                    ? true
                    : false
                }
                // defaultChecked={payload[item.name] ? payload[item.name] :null }
                onChange={(e) => {
                  handleInputFields(item.name, e.target.value);
                }}
                size="large"
              >
                <Radio.Button value={true} style={{ marginRight: "0.5rem" }}>
                  Yes
                </Radio.Button>
                <Radio.Button value={false} style={{ marginRight: "0.5rem" }}>
                  No
                </Radio.Button>
              </Radio.Group>
            </label>
          </Styles.SubFormDiv>
        );
      case "string":
        return (
          <Styles.SubFormDiv
            style={{
              marginTop: "0.5rem",
              display: item.name === "File Name" && "none",
            }}
          >
            <label style={{ display: "flex", flexDirection: "column" }}>
              {item.name}
            </label>
            {item.name === "Owner" ? (
              <div style={{ width: "94%" }}>
                <AutoComplete
                  className="custom-auto-select"
                  style={{ marginTop: "0px" }}
                  placeholder="Select Owner"
                  value={
                    payload && payload[item.name]
                      ? payload[item.name]
                      : attributeValues[item.name]
                      ? attributeValues[item.name]
                      : ""
                  }
                  // When user types
                  onSearch={(text) => {
                    handleInputFields(item.name, text);
                  }}
                  // When user selects an option
                  onSelect={(value, option) => {
                    if (value === "__add_new_owner__") {
                      setIsModalOpen(true);
                    } else {
                      handleInputFields(item.name, value);
                    }
                  }}
                  optionLabelProp="value"
                  dataSource={[
                    ...ownerList.map((owner, idx) => (
                      <Options key={idx} value={owner.Name}>
                        {owner.Name} {owner.Type ? `(${owner.Type})` : ""}
                      </Options>
                    )),
                    <Options value="__add_new_owner__" key="add_new_owner">
                      + Add New Owner
                    </Options>,
                  ]}
                >
                  <Input className="custom-auto-select-input" />
                </AutoComplete>
                {isModalOpen && (
                  <AddOwnerModal
                    title={"Add Owner Details"}
                    open={isModalOpen}
                    handleChange={handleChangeOwner}
                    handleCancel={handleCancel}
                    data={formDataOwner && formDataOwner}
                    handleSave={handleSave}
                  />
                )}
              </div>
            ) : (
              <Styles.InputBorder>
                <input
                  type="text"
                  disabled={view}
                  readOnly={view}
                  style={{
                    outline: "none",
                    border: "none",
                    width: "98%",
                    // marginTop:"0.5rem"
                  }}
                  value={
                    payload[item.name]
                      ? payload[item.name]
                      : // : attributeValues[item.name]
                        // ? attributeValues[item.name]
                        ""
                  }
                  onChange={(e) => {
                    handleInputFields(item.name, e.target.value);
                  }}
                />
              </Styles.InputBorder>
            )}
          </Styles.SubFormDiv>
        );
      case "image":
        return (
          <Styles.SubFormDiv style={{ marginTop: "0.5rem" }}>
            <label style={{ display: "flex", flexDirection: "column" }}>
              {item.name}
            </label>
            <Styles.InputBorder
              style={{
                alignItems: "center",
                background: "white",
                paddingInline: "1rem",
                display: "flex",
                justifyContent: "space-between",
                cursor: view ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (!view) {
                  const inputEl = document.getElementById(item.name);
                  if (inputEl) inputEl.click();
                }
              }}
            >
              {/* Hidden file input */}
              <input
                id={item.name}
                type="file"
                disabled={view}
                style={{ display: "none" }}
                onChange={async (e) => {
                  const res = await handleFileChange(e);
                  handleInputFields(item.name, res);
                }}
              />

              {/* Label that displays status */}
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "space-between",
                  cursor: view ? "not-allowed" : "pointer",
                }}
              >
                {isLoading ? (
                  <Spin />
                ) : payload[item.name] || attributeValues[item.name] ? (
                  <a
                    href={payload[item.name] || attributeValues[item.name]}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: "underline",
                      color: "#2A3DA3",
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    onClick={(e) => e.stopPropagation()} // prevent InputBorder click triggering input again
                  >
                    {extractFileNameFromUrl(
                      payload[item.name] || attributeValues[item.name]
                    )}
                  </a>
                ) : (
                  <span style={{ color: "#999" }}>Choose file</span>
                )}

                <Icon
                  className=""
                  style={{
                    fontSize: "23px",
                    background: "#2A3DA3",
                    padding: "8px",
                    borderRadius: "5px",
                    color: "white",
                  }}
                  type="upload"
                />
              </div>
            </Styles.InputBorder>
          </Styles.SubFormDiv>
        );
      case "int":
        return (
          <Styles.SubFormDiv style={{ marginTop: "0.5rem" }}>
            <label style={{ display: "flex", flexDirection: "column" }}>
              {item.name}
            </label>
            <Styles.InputBorder>
              <input
                type="text"
                disabled={view}
                readOnly={view}
                style={{
                  outline: "none",
                  border: "none",
                  width: "98%",
                  // marginTop:"0.5rem"
                }}
                value={
                  payload[item.name]
                    ? payload[item.name]
                    : attributeValues[item.name]
                    ? attributeValues[item.name]
                    : ""
                }
                onChange={(e) => {
                  const result = e.target.value.replace(/\D/g, "");
                  handleInputFields(item.name, result);
                }}
              />
            </Styles.InputBorder>
          </Styles.SubFormDiv>
        );
      case "float":
        return (
          <Styles.SubFormDiv
            style={{
              marginTop: "0.5rem",
              display:
                module === "Medicare V2" && item.name === "Premium" && "none",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                columnGap: "3px",
              }}
            >
              <label style={{ display: "flex", gap: "8px" }}>{item.name}</label>
              {(item.name === "Premium" ||
                (payload.hasOwnProperty("Medicare Type") &&
                  payload["Medicare Type"] === "Medicare Advantage" &&
                  [
                    "Part B (Medical Insurance) Premium",
                    "Part C (Medicare Advantage) Monthly Premium",
                  ].includes(item.name)) ||
                (payload.hasOwnProperty("Medicare Type") &&
                  payload["Medicare Type"] === "Original Medicare" &&
                  [
                    "Part B (Medical Insurance) Premium",
                    "Part D (Prescription Drug Plan) Monthly Premium",
                    "Medigap Supplement Plan Monthly Premium",
                  ].includes(item.name))) && (
                <span style={{ color: "red", fontSize: "20px" }}>*</span>
              )}
            </div>
            <Styles.InputBorder style={{ paddingLeft: "0px" }}>
              <span className="dollarSymbol">$</span>
              <InputNumber
                disabled={view}
                style={{
                  outline: "none",
                  border: "none",
                  width: "92%",
                  height: "3.5rem",
                }}
                className="Input"
                step={1}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                name={item.name}
                value={
                  payload[item.name]
                    ? payload[item.name]
                    : attributeValues[item.name]
                    ? attributeValues[item.name]
                    : "0"
                }
                onChange={(value) => {
                  handleInputFields(item.name, value);
                }}
              />
            </Styles.InputBorder>
          </Styles.SubFormDiv>
        );
      case "dropdown":
        return (
          <Styles.SubFormDiv
            style={{
              marginTop: "0.5rem",
              display:
                (item.name === "Linked Policies" ||
                  item.name === "Original Policies") &&
                "none",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                columnGap: "3px",
              }}
            >
              <label style={{ display: "flex", flexDirection: "column" }}>
                {item.name}
              </label>
              {["Annual or Monthly", "Annual / Monthly / One-Time"].includes(
                item.name
              ) && <span style={{ color: "red", fontSize: "20px" }}>*</span>}
            </div>
            {item.name !== "Annual or Monthly" &&
            item.name !== "Annual / Monthly / One-Time" &&
            item.name !== "Replacement Cost or Cash Value" &&
            item.name !== "Short Term or Long Term" &&
            item.name !== "Part C (Medicare Advantage) Network Type" ? (
              <DropDown
                readOnly={view}
                style={defaultStyles.styles.dropDown.m_smallDropdown1}
                listingStyle={{
                  ...defaultStyles.styles.dropDown.m_smallDropdown2,
                  height: "auto",
                }}
                name={item.name}
                title={item.name}
                list={
                  item.attribute_default_values && item.attribute_default_values
                }
                displayKey="value"
                disableSearch={false}
                key={item.name}
                value={payload && payload[item.name]}
                defaultValue={payload && payload[item.name]}
                placeholder={item.name}
                setSelectedItem={({ name, value }) => {
                  handleInputFields(name, value);
                }}
                // onChange={(e) => {
                //   console.log("eeeeeee",e)
                //   handleInputFields(item.name, e);
                // }}
                // options={
                //   item.options &&
                //   item.options.map((option) => ({
                //     value: option.value,
                //     label: option.value,
                //   }))
                // }
              />
            ) : (
              <Radio.Group
                disabled={view}
                style={{ marginTop: "0.5rem" }}
                value={
                  payload[item.name]
                    ? payload[item.name]
                    : attributeValues[item.name]
                    ? attributeValues[item.name]
                    : ""
                }
                onChange={(e) => {
                  handleInputFields(item.name, e.target.value);
                }}
                size="large"
              >
                {item.attribute_default_values ? (
                  ([
                    "Replacement Cost or Cash Value",
                    "Short Term or Long Term",
                  ].includes(item.name)
                    ? [...item.attribute_default_values].reverse()
                    : item.attribute_default_values
                  ).map((att, index) => (
                    <Radio.Button
                      key={index}
                      value={att.value}
                      style={{ marginRight: "0.5rem" }}
                    >
                      {att.value}
                    </Radio.Button>
                  ))
                ) : (
                  <React.Fragment>
                    <Radio.Button
                      value={true}
                      style={{ marginRight: "0.5rem" }}
                    >
                      Yes
                    </Radio.Button>
                    <Radio.Button
                      value={false}
                      style={{ marginRight: "0.5rem" }}
                    >
                      No
                    </Radio.Button>
                  </React.Fragment>
                )}
              </Radio.Group>
            )}
          </Styles.SubFormDiv>
        );
      case "date":
        return (
          <Styles.SubFormDiv style={{ marginTop: "0.5rem" }}>
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                columnGap: "3px",
              }}
            >
              <label style={{ display: "flex", flexDirection: "column" }}>
                {item.name === "Goal Date" ? (
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                    }}
                  >
                    {item.name}{" "}
                    <img
                      style={{
                        cursor: "pointer",
                        height: "24px",
                        width: "24px",
                      }}
                      onClick={() => {
                        showTooltipModal();
                      }}
                      src={helpIcon}
                      alt="help"
                    />
                    <Modal
                      centered
                      visible={tooltipModal}
                      footer={null}
                      onCancel={handleTooltipCancel}
                    >
                      <div className="modaltitle"> Goal Date</div>
                      <div style={{}}>
                        <div className="">
                          <div className="inputTitle">
                            Changing the Goal Date requires the recalculation of
                            the amount you need and the values of the Assets
                            that have been assigned to the Goal. Because of the
                            complexity of this, please remove the Assets that
                            have been assigned first, then adjust the Goal Date.
                          </div>
                        </div>
                      </div>
                    </Modal>
                  </div>
                ) : (
                  item.name
                )}
              </label>
              {["Policy Start Date", "Policy End Date"].includes(item.name) && (
                <span style={{ color: "red", fontSize: "20px" }}>*</span>
              )}
            </div>
            <Styles.InputBorder
              style={{
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <DatePicker
                // disabled={view}
                disabled={view}
                format={"MM-DD-YYYY"}
                style={{
                  outline: "none",
                  border: "none",
                  borderRadius: "0.5rem",
                }}
                key={item.name}
                placeholder={item.name}
                value={
                  payload[item.name]
                    ? moment(payload[item.name])
                    : moment(attributeValues[item.name] || new Date())
                }
                // defaultValue={
                //   values[item.name]
                //     ? moment(values[item.name], item.format)
                //     : ""
                // }
                onChange={(date, dateString) => {
                  handleInputFields(item.name, dateString);
                }}
              />
            </Styles.InputBorder>
          </Styles.SubFormDiv>
        );
      default:
        console.error("invalid DataType Detected :::: ", item.dataType);
        break;
        {
          /*  return (
                  <Styles.SubFormDiv style={{ marginTop: "0.5rem" }}>
                    <label style={{ display: "flex", flexDirection: "column" }}>
                      {item.name}
                      <Styles.Input
                        key={item.name}
                        placeholder={item.name}
                        defaultValue={values[item.name]}
                        onChange={(e) => handleInputFields(item.name, e.target.value)}
                      />
                    </label>
                  </Styles.SubFormDiv>
                ); */
        }
    }
  };
  const { view } = useParams();

  return (
    <React.Fragment>
      <div className="active-tab-heading">{activeTabName}</div>
      <Styles.FormDiv>
        {inputFields &&
          inputFields.length > 0 &&
          inputFields
            .filter((field) => data && data[field]) // Ensure only valid fields are sorted
            .sort((a, b) => {
              if (data && data[a] && data[b]) {
                if (
                  data &&
                  data[a].groupPriorityValue < data &&
                  data[b].groupPriorityValue
                )
                  return -1;
                if (
                  data &&
                  data[a].groupPriorityValue > data &&
                  data[b].groupPriorityValue
                )
                  return 1;
              }
              return 0;
            })
            .map((item, indx) => {
              // console.log("item in mappppp", item);
              if (data && data[item] && data[item].formGroupName)
                return <React.Fragment key={indx}></React.Fragment>;
              return (
                <React.Fragment key={indx}>
                  {DynamicComponentGenerator(item)}
                </React.Fragment>
              );
            })}
      </Styles.FormDiv>
      {console.log("groupedFields", groupedFields, tabRows[activeTabName])}
      {activeTabName && activeTabName === "UMBRELLA INSURANCE INFORMATION" && (
        <Styles.FormDiv>
          <UmbrellaInsuranceTable
            setPayload={setPayload}
            setAttributeValues={setAttributeValues}
            payload={payload}
            attributeValues={attributeValues}
          />
        </Styles.FormDiv>
      )}
      {groupedFields && groupedFields.length > 0 && (
        <div className="goalsGroupFields">
          {console.log("tabRows22", tabRows[activeTabName], inputFields)}
          {groupedFields.map((group) => (
            <div
              key={group.groupName}
              style={{ flexBasis: "100%", width: "80%", marginBottom: "2rem" }}
            >
              <div className="active-group-name-heading">{group.groupName}</div>
              {console.log("tabRows", tabRows)}
              <Collapse>
                <Panel header={group.groupName}>
                  <React.Fragment>
                    {group.groupName !== "Advanced Options" ? (
                      <InsuranceSubFormTable
                        title={group.groupName}
                        rows={
                          tabRows[activeTabName] ? tabRows[activeTabName] : []
                        }
                        colsFormat={group.cols}
                        addNewButton={view ? false : true}
                        deleteAssignAsset={(row) => {
                          console.log("row", row);
                        }}
                        cbFormChange={(rows) => {
                          handleFormInputChange(group.groupName, rows);
                          // if (
                          //   activeTabName === "ASSIGN ASSET" &&
                          //   group.groupName === "Assets to Assign to Goal"
                          // ) {
                          //   // setAssetsAssign(rows);
                          //   console.log("rrrrrrrr", rows);
                          // }
                        }}
                      />
                    ) : (
                      <React.Fragment>
                        {group.groupAttributes &&
                          group.groupAttributes.length > 0 &&
                          group.groupAttributes.map((item, indx) => {
                            return (
                              <React.Fragment key={indx}>
                                {SubFieldGenerator(item)}
                              </React.Fragment>
                            );
                          })}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                </Panel>
              </Collapse>
            </div>
          ))}
        </div>
      )}
    </React.Fragment>
  );
};
